import styled from 'styled-components';

export const Container = styled.div`
  width: 62%;
  box-shadow: 0px 3px 6px #00000066;
  border-style: solid;
  border-width: 0.5px;
  border-color: #707070;
  border-radius: 16px;
  z-index: 10;
  margin-bottom: 30px;
  margin-left: 15px;
  margin-right: 15px;

  @media (min-width: 1950px) {
    width: 1000px;
    height: auto;
  }

  @media (max-width: 1350px) {
    width: 55%;
    height: auto;
  }

  @media (max-width: 1200px) {
    width: 95%;
    height: auto;
  }

  @media (max-width: 870px) {
    width: 95%;
    height: auto;
  }

`;

// export const Container = styled.div`
//   //width: 62%;
//   width: 665px;
//   box-shadow: 0px 3px 6px #00000066;
//   border-style: solid;
//   border-width: 0.5px;
//   border-color: #707070;
//   border-radius: 16px;
//   z-index: 10;
//   margin-bottom: 30px;
//   margin-left: 15px;
//   margin-right: 15px;

//   @media (max-width: 1510px) {
//     width: 790px;
//   }
//   @media (max-width: 1330px) {
//     width: 790px;;
//   }
//   @media (max-width: 1105px) {
//     width: 635px;
//   }
//   @media (max-width: 972px) {
//     width: 525px;;
//   }
//   @media (max-width: 870px) {
//     width: 95%;
//     height: auto;
//   }

// `;

export const Legend = styled.div`
  padding: 8px 12px;
  position: absolute;
  bottom: 39px;
  width: 100%;
  background: #0000008f;
  text-align: center;
`;

export const ButtonTitle = styled.div`
  font: normal normal bold 15px/26px Roboto;
  color: #FFFFFF;
`;

export const ButtonLink = styled.div`
  font: normal normal 900 13px/19px Roboto;
  letter-spacing: 0.34px;
  color: #000FFF;
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: right;
  align-items: right;
  flex-direction: row;

  @media (max-width: 769px) {
    justify-content: center;
    align-items: center;
  }
`;

export const BodyContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0px 20px 20px 20px;

  height: 250px;
  overflow-y: auto;

  @media (max-width: 770px) {
    height: 300px;
  }
`;


export const ImagePush = styled.h1`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 130px;
  max-height: 130px;

  margin-top: ${props => (props.index === 0 ? '25px' : '0px')};
  
  @media (max-width: 1320px) {
    //margin-top: 50px;
    margin-top: ${props => (props.index === 0 ? '50px' : '0px')};
  }

  @media (max-width: 975px) {
    //margin-top: 70px;
    margin-top: ${props => (props.index === 0 ? '70px' : '0px')};
  }

  @media (max-width: 875px) {
    //margin-top: 10px;
    margin-top: ${props => (props.index === 0 ? '10px' : '0px')};
  }

  @media (max-width: 770px) {
    //margin-top: 0px;
    margin-top: ${props => (props.index === 0 ? '0px' : '0px')};
  }

`;

export const Title = styled.h1`
  text-align: center;
  font: normal normal bold 18px/29px Roboto;
  letter-spacing: 0.53px;
  color: #000000;
`;

export const Caption = styled.h1`
  text-align: center;
  font: normal normal normal 12px/24px Roboto;
  letter-spacing: 0.38px;
  color: #000000;
`;
